module.exports = __webpack_public_path__ + "img/12.d69f4d23.png";